const __login = {
  method: 'POST',
  url: 'auth/login',
};

const __getAuthData = {
  method: 'GET',
  url: 'auth/me',
};

const __getSipCredentials = {
  method: 'GET',
  url: 'sip/creds',
};

const __getSipMsisdn = {
  method: 'GET',
  url: 'sip/msisdn',
};

const __updateSipSetting = {
  method: 'POST',
  url: 'sip/setting',
};

const __getSipSetting = {
  method: 'GET',
  url: 'sip/setting',
};

export { __login, __getAuthData, __getSipCredentials, __getSipMsisdn, __updateSipSetting, __getSipSetting };
